import Vue from 'vue';
import Toasted, { ToastObject } from 'vue-toasted';

Vue.use(Toasted, {
  iconPack: 'mdi',
  keepOnHover: true,
  containerClass: 'cfs-toast',
  action: {
    icon: 'close-circle',
    onClick: (e: unknown, toastObject: ToastObject) => {
      toastObject.goAway(0);
    },
  },
  duration: 3000,
});
